// extracted by mini-css-extract-plugin
export default {"mnInput":"mn-input_mnInput__xF2xv","icon":"mn-input_icon__ttIHx","input":"mn-input_input__N9jaD","textarea":"mn-input_textarea__PdJHe"};